<div class="minimal-modal-wrapper p-4 text-center">
    <button type="button" class="btn-close-minimal" (click)="activeModal.dismiss('cancel')">
        <span class="material-symbols-outlined">close</span>
    </button>

    <div class="icon-container mb-3">
        <div class="icon-shape warning-shape">
            <span class="material-symbols-outlined">warning</span>
        </div>
    </div>

    <h3 class="modal-title-clean">Sito già presente</h3>
    <p class="modal-text mb-4">
        L'URL che hai inserito risulta già scansionato in questo indice. <br>
        Se procedi, i vecchi dati verranno cancellati e verrà avviata una nuova scansione.
    </p>

    <div class="duplicates-list text-start mb-4">
        @for (conflict of duplicatesList; track conflict.incomingFile) {
            <div class="duplicate-item">
                <span class="material-symbols-outlined text-danger">link</span>
                <span class="file-name">{{ conflict.incomingFile }}</span>
            </div>
        }
    </div>

    <div class="modal-actions d-flex flex-column gap-3">
        
        <button class="btn-action-card replace-card text-start" (click)="resolveConflict('replace')">
            <div class="d-flex align-items-center gap-3">
                <span class="material-symbols-outlined icon-large">find_replace</span>
                <div>
                    <h5 class="mb-1 fw-bold text-dark">Sostituisci sito esistente</h5>
                    <p class="mb-0 text-muted small">Cancella i dati precedenti e avvia l'ingestion.</p>
                </div>
            </div>
        </button>

        <button type="button" class="btn-action btn-cancel w-100 mt-2" (click)="activeModal.dismiss('cancel')">
            Annulla
        </button>
    </div>
</div>